import { useAuth } from "../auth/AuthContext.js";

/**
 * Emma OS GENERATE productization, Phase B correction: this used to
 * default to `accessibleTenants[0]` for a non-owner member — silently
 * wrong the moment such a user belonged to more than one workspace (see
 * the git history on this file for the original doc comment explaining
 * that gap). `AuthContext.selectedTenantId` is now the single source of
 * truth: it is initialized from a real workspace-switcher selection
 * (persisted per-browser, always re-validated against the live
 * `workspaces`/`videoManagementTenantId` list on every `/auth/me`
 * refresh — see AuthContext's own doc comment), defaulting to the
 * platform OWNER's `videoManagementTenantId` (Emma's own management
 * tenant) or the caller's first real workspace, never an arbitrary
 * tenant. The actual switcher UI lives in `App.tsx`'s `TopNav`.
 */
export function useCurrentTenant(): string | null {
  return useAuth().selectedTenantId;
}
